document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('[data-products-from-collection-body]');

  sliders.forEach(slider => {
    new window.Splide(slider, {
      type: 'carousel',
      perPage: 4,
      pagination: false,
      gap: 60,
      breakpoints: {
        1068: {
          perPage: 2,
          gap: 60,
        },
        768: {
          perPage: 2,
          paddingRight: '70px',
          arrows: false,
          gap: 15,
        },
      },
    }).mount();
  });
});
